import { Statistics } from '../Statistics';
import styles from './styles.module.scss';

export const InfoColumn = ({ tab }: { tab: 'stats' | 'events' }) => {
  return (
    <div className={styles.info}>
      {(() => {
        switch (tab) {
          case 'stats':
            return <Statistics />;
          case 'events':
            return <div className={styles.placeholder}>Some other items</div>;
          default:
            return null;
        }
      })()}
    </div>
  );
};
